<template>
  <b-modal
    :hide-footer="true"
    centered
    size="lg"
    id="agendamentos-modal"
    @hidden="$bvModal.hide('agendamentos-modal')"
  >
    <template #modal-title>
      <strong class="font-size-19">
        Agenda - {{ dataAtendimento }} ({{ expediente }})
      </strong>
    </template>
    <section>
      <table class="b-table table table-bordered bg-white b-table-stacked-md table-sm">
        <tbody>
          <tr>
            <td colspan="2">
              <strong> Dados do atendimento </strong>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Técnico selecionado: <strong> {{ tecnico }} </strong>
            </td>
          </tr>
          <tr>
            <td>
              Serviço Socioassistencial:
              <strong> {{ atendimento?.servico?.nome }} </strong>
            </td>
            <td>
              Forma de acesso:
              <strong> {{ atendimento?.forma_acesso?.nome }} </strong>
            </td>
          </tr>
          <tr>
            <td>
              Contato:
              <strong> {{ atendimento?.contato }} </strong>
            </td>
            <td>
              Data da solicitação:
              <strong> {{ atendimento?.data_cadastro | formatDate }} </strong>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Local de atendimento:
              <strong> {{ atendimento?.local_atendimento?.descricao }} </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <form @submit.prevent="saveAgendamento">
      <section class="row mt-3">
        <div class="col-12 border-top">
          <h4 class="font-weight-bold mt-3 mb-2">
            Agendamento
          </h4>
        </div>

        <form-calendar
          :required="true"
          grid="6"
          label="Horário de início"
          mode="time"
          id="horarioInicio"
          name="horarioInicio"
          v-model="item.hora_inicio"
        />

        <form-calendar
          :required="true"
          grid="6"
          label="Horário de término"
          mode="time"
          id="horarioTermino"
          name="horarioTermino"
          v-model="item.hora_fim"
        />
      </section>
      <section class="d-flex flex-row justify-content-end mt-3" style="column-gap: 5px">
        <button
          class="btn btn-submit-agendamento-cadastro btn-success mr-0"
          data-style="zoom-in"
          type="submit"
        >
          {{ $t("Confirmar") }}
          <i
            class="mdi mdi-check"
          />
        </button>
      </section>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: [
    "atendimento",
    "tecnico",
    "dataAtendimento",
    "item",
    "saveAgendamento",
    "expediente"
  ]
}
</script>
